var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"section-base__title-box"},[_c('div',{staticClass:"section-base__title"},[_vm._v(_vm._s(_vm.RouteText.STATEMENTS_JOINT))])]),_c('div',[_c('StatementsJointTable',{attrs:{"pagination-show":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }